import React, { Component, Fragment } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Toastr, Button, Label, Input } from "@revvsales/components";

import { EVENTS } from "../../../constants";
import { DocumentUtils, GlobalUtils, AmplitudeUtils } from "../../../utils";
import { getOrderedSignersList } from "../../../utils/quotationUtils";

import {
  sendDocForSignature,
  legallyBindedSignatory,
} from "../../../actions/DocumentActions/services";
import {
  makeSendForSignatureButton,
  showIframeDocSign,
} from "../../../actions/DocumentActions";
import { IntegrationsActions } from "../../../actions";

const { getCRMInitData } = IntegrationsActions;
const { getExportContent, _emailIsValid } = DocumentUtils;
const { readDataFromLocalStorage } = GlobalUtils;
class SendToDocSignScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      showContent: false,
      parentText: "",
      childText: "",
      postEnvelopeData: {
        recipients: {
          signers: [
            {
              email: props.userEmail,
              firstName: props.userFirstName,
              lastName: props.userLastName,
              recipientId: 1,
            },
          ],
        },
        emailSubject: "",
        esignType: "OS", // This is hard coded for now since we support only one esignature tool
        pdfFile: {},
      },
      errMsg: "",
    };
  }

  componentDidMount = () => {
    this.props.getCRMInitData();
    legallyBindedSignatory()
      .then(response => {
        if (response.remaining_esigns < 1) {
          this.setState({
            parentText: "This document or signature is NOT LEGALLY BINDING.",
            childText:
              "To integrate your own e-sign platform, write to us at help@revv.so or chat with us.",
          });
        } else {
          this.setState({
            parentText:
              "We've added free e-signs to your Revv account to facilitate contact-free contract closures during the ongoing COVID-19 pandemic.",
            childText: "All e-signs will now be legally binding.",
          });
        }
      })
      .catch(() => {
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _onAddDefaultField = () => {
    if (!this.state.errMsg) {
      const data = { ...this.state.postEnvelopeData };
      data.recipients.signers.push({
        email: "",
        firstName: "",
        lastName: "",
        recipientId: data.recipients.signers.length + 1,
      });
      this.setState(() => ({ postEnvelopeData: data }));
    }
  };

  // Handle dynamic  Fields
  _handleValue = (e, i, name) => {
    const data = { ...this.state.postEnvelopeData };

    let errorMsg = this.state.errMsg;
    if (name === "email") {
      errorMsg = "";
      data.recipients.signers[i][name] = e.target.value;
      if (
        e.target.value.length > 0 &&
        _emailIsValid(e.target.value) === false
      ) {
        data.recipients.signers[i].notValid = true;
      } else {
        delete data.recipients.signers[i].notValid;
      }
    } else {
      data.recipients.signers[i][name] = e.target.value;
    }
    this.setState(() => ({ postEnvelopeData: data, errMsg: errorMsg }));
  };

  _handleEmailOnBlur = (index, email) => {
    const signers = [...this.state.postEnvelopeData.recipients.signers];
    if (index > 0 && email) {
      signers.splice(-1, 1);
      const findExistingEmail = signers.find(signer => signer.email === email);
      console.debug("findExistingEmail", findExistingEmail);

      if (findExistingEmail) {
        this.setState(() => ({
          errMsg: `Recipient email ${index + 1} has already added to the list.`,
        }));
      }
    }
  };

  // Note :: don't remove the commented code, may come later
  // Handle Subject  Field
  // _handleSubject = e => {
  //   const data = { ...this.state.postEnvelopeData };
  //   data.emailSubject = e;
  //   this.setState(() => ({ postEnvelopeData: data }));
  // };

  updateButtonStatus = data => {
    let status = false;
    if (this.state.errMsg) {
      status = true;
    }
    if (data.recipients.signers.length > 0) {
      data.recipients.signers.forEach(d => {
        if (
          d.email === "" ||
          d.firstName === "" ||
          d.lastName === "" ||
          d.notValid === true
        ) {
          status = true;
        }
      });
    } else {
      status = true;
    }

    return status;
  };

  _sendtoDocuSign = () => {
    this.setState({
      showLoader: true,
    });
    const { document, components, layout } = this.props;
    const previewContent = getExportContent(document, components);
    const data = { ...this.state.postEnvelopeData };
    data.pdfFile = previewContent;
    data.pdfFile.content.schema_version = "1.0";

    const signers = getOrderedSignersList(document.signatories, layout);

    data.pdfFile.content.signers = signers.reduce((accum, item) => {
      accum[item.user_email] = item;
      return accum;
    }, {});

    // data.docName = this.props.document.docNo;
    data.docName = this.props.document.name;
    this.setState(() => ({ postEnvelopeData: data }));
    sendDocForSignature(this.props.document.id, data)
      .then(response => {
        if (response.DocuSignEnvelopeInformation.tagging_view_url !== "") {
          if (response.DocuSignEnvelopeInformation.esignType === "OS") {
            /*
              OS denotes OpenSpan which means that the reponse contains a URL that needs
              to open in an iframe.
            */
            this.props.showIframeDocSign(
              response.DocuSignEnvelopeInformation.tagging_view_url,
              response.DocuSignEnvelopeInformation.envelopeId,
            );
          } else {
            /*
              For now it is assumed that the other option is DocuSign so a redirection is 
              required.
            */
            window.open(response.DocuSignEnvelopeInformation.tagging_view_url);
          }
        }
        this.props.togglePopUp("showSignatureMoveModal", false);
        this.setState({
          showLoader: false,
        });
        const payload = {
          status: "PREPARE_FOR_SIGNATURE",
          stage: "Customer Review",
        };
        this.props.makeSendForSignatureButton(payload);
        AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.SIGNATORY_ADDED, {
          ...this.props.document,
          signatories: this.state.postEnvelopeData.recipients.signers.length,
        });
      })
      .catch(() => {
        this.setState({
          showLoader: false,
        });
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  showContent = showStatus => {
    if (showStatus === "More") {
      this.setState({
        showContent: true,
      });
    } else {
      this.setState({
        showContent: false,
      });
    }
  };

  _onRemoveRecipient = index => {
    const data = { ...this.state.postEnvelopeData };
    data.recipients.signers.splice(index, 1);
    this.setState(() => ({ postEnvelopeData: data, errMsg: "" }));
  };

  render() {
    const {
      errMsg,
      parentText,
      childText,
      postEnvelopeData,
      showContent,
      showLoader,
    } = this.state;
    const errMsgSpace =
      errMsg !== "" ? (
        <div className="error-message-wrapper docsharingpopup-errormg-wrapper">
          {errMsg}
        </div>
      ) : null;

    return (
      <Modal
        open
        onClose={() => this.props.togglePopUp("showSignatureMoveModal", false)}
        closeOnOverlayClick={false}
        center>
        <div className="signature-envelope-wrapper">
          <div>
            <div className="popup-header">Enter signatory details</div>
          </div>

          {errMsgSpace}
          <div>
            {postEnvelopeData.recipients.signers.map((data, i) => (
              <Fragment>
                <div className="form-row">
                  <div className="col-md-3">
                    <Label>
                      First name ({i + 1})
                      <span
                        className="required-input"
                        data-test="sendToDocSignScreen-firstname-required-input-icon">
                        *
                      </span>
                    </Label>
                    <Input
                      type="text"
                      value={data.firstName}
                      placeholder="First name here"
                      onChange={e => this._handleValue(e, i, "firstName")}
                      data-test="sendToDocSignScreen-userFirstName"
                    />
                  </div>
                  <div className="col-md-3">
                    <Label>
                      Last name ({i + 1})
                      <span
                        className="required-input"
                        data-test="sendToDocSignScreen-lastname-required-input-icon">
                        *
                      </span>
                    </Label>
                    <Input
                      type="text"
                      value={data.lastName}
                      placeholder="Last name here"
                      onChange={e => this._handleValue(e, i, "lastName")}
                      data-test="sendToDocSignScreen-userLastName"
                    />
                  </div>
                  <div className="col-md-5">
                    <Label>
                      Recipient email
                      <span
                        className="required-input"
                        data-test="sendToDocSignScreen-email-required-input-icon">
                        *
                      </span>
                    </Label>
                    <Input
                      style={
                        data.notValid
                          ? { borderColor: "red" }
                          : { borderColor: "" }
                      }
                      type="text"
                      value={data.email}
                      placeholder="Email here"
                      onChange={e => this._handleValue(e, i, "email")}
                      onBlur={() => this._handleEmailOnBlur(i, data.email)}
                      data-test="sendToDocSignScreen-userEmail"
                    />
                  </div>
                  <div className="col-md-1 trashicon">
                    <span
                      className="btn-icon"
                      onClick={() => this._onRemoveRecipient(i, data)}
                      onKeyPress={() => this._onRemoveRecipient(i, data)}
                      role="button"
                      tabIndex="0"
                      data-test="sendToDocSignScreen-delete-icon">
                      <FontAwesomeIcon icon={["far", "trash-alt"]} />
                    </span>
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
          <div className="addsign-container">
            <Tooltip
              placement="bottom"
              overlay={`${errMsg ? "" : "Add another recipient"}`}>
              <div
                className={`revv-btn-secondary-sm addsign-btn ${
                  errMsg ? "disabled" : ""
                }`}
                onClick={this._onAddDefaultField}
                onKeyPress={this._onAddDefaultField}
                role="button"
                tabIndex="0"
                data-test="sendToDocSignScreen-add-recipient-btn">
                <i className="plusiconadd">
                  <FontAwesomeIcon icon={["far", "plus"]} className="" />
                </i>
              </div>
            </Tooltip>
          </div>
          {/* Note :: don't remove the commented code, may come later */}
          {/* <div>
            <Label>
              Subject<span className="required-input">*</span>
            </Label>
            <Input
              type="text"
              value={this.state.postEnvelopeData.emailSubject}
              placeholder="Email Subject here"
              onChange={e => this._handleSubject(e.target.value)}
            />
          </div> */}
          <div className="contentmargin">
            <span className="content-size">
              {parentText}
              <span
                style={showContent ? { display: "none" } : { display: "" }}
                className="showicon"
                role="button"
                onKeyPress={this.showContent}
                tabIndex="0"
                onClick={() => this.showContent("More")}>
                Show More
              </span>
              {showContent ? (
                <span>
                  {childText}{" "}
                  <span
                    className="showicon"
                    role="button"
                    onKeyPress={this.showContent}
                    tabIndex="0"
                    onClick={() => this.showContent("Less")}>
                    Show less
                  </span>
                </span>
              ) : (
                ""
              )}
            </span>
          </div>
        </div>
        <section className="createquotepopup-footer popup-footer clearfix">
          <div className="footer-actions">
            <Fragment>
              <Button
                className="btn btn-transparent createquotepopup-footer-cancelbtn"
                data-test="sendToDocSignScreen-discard-btn"
                onClick={() =>
                  this.props.togglePopUp("showSignatureMoveModal", false)
                }>
                Discard
              </Button>
              <Button
                disabled={this.updateButtonStatus(postEnvelopeData)}
                className="btn btn-primary"
                data-test="sendToDocSignScreen-contiue-btn"
                isLoading={showLoader}
                onClick={() => this._sendtoDocuSign()}>
                Continue
              </Button>
            </Fragment>
          </div>
        </section>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const user = readDataFromLocalStorage("revvsalesUser");
  let userFirstName = "";
  let userLastName = "";
  let userFullName = "";
  let userEmail = "";
  // let defaultSubject = "";

  const { document, components, layout } = state.DocumentStore;

  const { crmConfig } = state.SettingsStore;

  if (user && user.first_name && user.last_name && user.user_email) {
    userFirstName = user.first_name;
    userLastName = user.last_name;
    userFullName = `${user.first_name} ${user.last_name}`;
    userEmail = user.user_email;
    // defaultSubject = `${userFullName} has requested you to sign the document`;

    // if (document.name) {
    //   defaultSubject = `${userFullName} has requested you to sign ${
    //     document.name
    //   }`;
    // }
  }

  return {
    components,
    layout,
    document,
    crmConfig,
    userFullName,
    userLastName,
    userFirstName,
    userEmail,
    // defaultSubject,
  };
};

const mapDispatchToProps = {
  makeSendForSignatureButton,
  getCRMInitData,
  showIframeDocSign,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SendToDocSignScreen);



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationTopbarBtns/SendToDocSignScreen.js